import {Button, Col, Row, Tooltip} from 'antd';
import {ColumnsType} from 'antd/lib/table/Table';
import {RiDeleteBin5Line, RiEdit2Line} from 'react-icons/ri';
import {useIntl} from 'react-intl';
import {useLocaleContext} from 'src/domain/utility/AppContextProvider/LocaleContextProvide';
import IntlMessages from 'src/domain/utility/IntlMessages';
import {GetAllReasonDescriptionsListDto} from 'src/shared/services/product-rejection-reasons/dto/get-all-reason-descriptions-list-dto';

const TableColumn = (
  editRejectionReasonsOptionModal: (value: any) => void,
  deleteRejectionReasonsOption: (value: any) => void,
): ColumnsType<any> => {
  const {messages} = useIntl();

  const {locale}: any = useLocaleContext();

  return [
    {
      title: <IntlMessages id='specificationAttributes.edit.optionName' />,
      dataIndex: 'Value',
      key: 'Value',
      width: '60%',
      render: (value: string, record: GetAllReasonDescriptionsListDto) => {
        return (
          record?.Locales?.find((item) => item.LanguageId === locale.code)
            ?.LocaleValue ?? value
        );
      },
    },
    {
      title: <IntlMessages id='common.Action' />,
      key: 'action',
      render: (value, record: GetAllReasonDescriptionsListDto, index) => {
        return (
          <Row justify='center'>
            <Col>
              <Tooltip
                title={messages[
                  'tooltip.specificationAttributes.edit.editOption'
                ].toString()}>
                <Button
                  onClick={() => editRejectionReasonsOptionModal(record)}
                  type='link'
                  icon={<RiEdit2Line />}
                />
              </Tooltip>
            </Col>

            <Col>
              <Tooltip
                title={messages[
                  'tooltip.specificationAttributes.edit.removeOption'
                ].toString()}>
                <Button
                  onClick={() => deleteRejectionReasonsOption(record)}
                  icon={<RiDeleteBin5Line className='removeIcon' />}
                  type='link'
                  danger
                />
              </Tooltip>
            </Col>
          </Row>
        );
      },
      className: 'col-actions',
      width: 100,
      ellipsis: true,
    },
  ];
};

export default TableColumn;
